/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CommentTagType = {
    ReworkRequested: 'ReworkRequested',
    Completed: 'Completed',
    Approved: 'Approved',
    ReviewPending: 'ReviewPending'
} as const;
export type CommentTagType = typeof CommentTagType[keyof typeof CommentTagType];


export function CommentTagTypeFromJSON(json: any): CommentTagType {
    return CommentTagTypeFromJSONTyped(json, false);
}

export function CommentTagTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentTagType {
    return json as CommentTagType;
}

export function CommentTagTypeToJSON(value?: CommentTagType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the CommentTagType interface.
 */
 export function instanceOfCommentTagType(value: any): value is CommentTagType {
    return Object.values(CommentTagType).includes(value)
}

